import { Injectable } from "@angular/core";
import { StoreService } from "angular-simple-redux-lib";
import { AverageLeadtimesState } from "./models/models";

@Injectable()
export class AverageLeadtimesStateService extends StoreService<AverageLeadtimesState> {}
